/**
 * Demo.jsx - Landing spot for the "employer demo" link.
 *
 * Visiting /demo logs the visitor straight into a shared demo account
 * (no credentials needed) and drops them on the dashboard.
 */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setToken } from '../utils/api';

const Demo = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const response = await api.demoLogin();
        setToken(response.access_token);
        localStorage.setItem('user_role', response.role);
        localStorage.setItem('user_first_name', response.first_name);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        setError(err.message || 'Could not start the demo. Please try again.');
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#050d1f] text-white flex items-center justify-center">
      {error ? (
        <div className="text-center">
          <p className="text-red-400 mb-4">{error}</p>
          <button onClick={() => navigate('/')} className="text-[#4d7cff] hover:underline">
            Back to login
          </button>
        </div>
      ) : (
        <p className="text-white/60">Loading demo…</p>
      )}
    </div>
  );
};

export default Demo;
